import { render, staticRenderFns } from "./CustomersNeopag.vue?vue&type=template&id=0a6e63e7&"
var script = {}
import style0 from "./CustomersNeopag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports